// extracted by mini-css-extract-plugin
export default {"modal":"ModalWindow_modal__oBSLx","content":"ModalWindow_content__FcEBq","button":"ModalWindow_button__y7Rsr"};